import { dispatchPromise } from './action-helpers';
import { createTempId } from 'utils/helpers';

const DEFAULT_CHECKLIST_PROPS = {
    id: null,
    name: ''
};

const DEFAULT_CHECKLIST_ITEM_PROPS = {
    id: null,
    name: '',
    completed: false
};

export const createChecklist = (taskId, checklistProps) => {
    return dispatchPromise({
        type: 'CHECKLIST_CREATE_REQUESTED',
        payload: {
            taskId,
            checklist: Object.assign({}, DEFAULT_CHECKLIST_PROPS, checklistProps, {
                id: createTempId(),
                isNew: true
            })
        }
    });
}

export const fetchChecklist = checklistId => {
    return dispatchPromise({
        type: 'CHECKLIST_FETCH_REQUESTED',
        payload: { checklistId }
    });
}

export const updateChecklist = (checklistId, checklistProps, preventSave) => {
    return dispatchPromise({
        type: 'CHECKLIST_UPDATE_REQUESTED',
        preventSave,
        payload: {
            checklistId,
            checklistProps
        }
    });
}

export const removeChecklist = checklistId => {
    return dispatchPromise({
        type: 'CHECKLIST_REMOVE_REQUESTED',
        payload: {
            checklistId
        }
    });
}

export const createChecklistItems = (checklistId, checklistItems) => {
    return dispatchPromise({
        type: 'CHECKLIST_ITEMS_CREATE_REQUESTED',
        payload: {
            checklistId,
            checklistItems: checklistItems.map(itemProps => ({
                ...DEFAULT_CHECKLIST_ITEM_PROPS,
                ...itemProps,
                id: createTempId()
            }))
        }
    });
}

export const updateChecklistItem = (checklistId, checklistItemId, checklistItemProps, preventSave) => {
    return dispatchPromise({
        type: 'CHECKLIST_ITEM_UPDATE_REQUESTED',
        preventSave,
        payload: {
            checklistId,
            checklistItemId,
            checklistItemProps
        }
    });
}

export const removeChecklistItem = (checklistId, checklistItemId) => {
    return dispatchPromise({
        type: 'CHECKLIST_ITEM_REMOVE_REQUESTED',
        payload: {
            checklistId,
            checklistItemId
        }
    });
}
